// extracted by mini-css-extract-plugin
export default {"container":"wrapper_container__5ZF98","title":"wrapper_title__yjImJ"};